// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".powered-by__logo[data-v-71afdf46]{padding:16px 32px;width:100%;height:100%;vertical-align:middle;text-align:center}.powered_by_image[data-v-71afdf46]{width:100%;height:56px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
